/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAcceleratedDepreciationRequest,
  PresenterAssetType,
  PresenterBIIDResponse,
  PresenterBulkChangeMovementReq,
  PresenterBulkDeleteFixedAssetRequest,
  PresenterBulkRetireFixedAssetRequest,
  PresenterBulkUpdateAssetTypeRequest,
  PresenterBulkUsageFixedAssetRequest,
  PresenterCancelAcceleratedDepreciationRequest,
  PresenterCheckBulkStartUsageWarningsRequest,
  PresenterCheckFixedAssetWarningsResponse,
  PresenterCorrectFixedAssetRequest,
  PresenterCreateFixedAssetRequest,
  PresenterDepreciationMonthlyResponse,
  PresenterDepreciationRecalculateHistoryResponse,
  PresenterDivideAssetPreviewRequest,
  PresenterDivideAssetPreviewResponse,
  PresenterDivideAssetRequest,
  PresenterDivideStandardDateRequest,
  PresenterDivideStandardDateResponse,
  PresenterEditFixedAssetRequest,
  PresenterError,
  PresenterFixedAssetAnnualDepreciationResponse,
  PresenterFixedAssetBookInformationRequest,
  PresenterFixedAssetBookInformationResponse,
  PresenterFixedAssetBookValueDividingRequest,
  PresenterFixedAssetBookValueDividingResponse,
  PresenterFixedAssetDepreciationResponse,
  PresenterFixedAssetRanges,
  PresenterFixedAssetsActionStatusReq,
  PresenterFixedAssetsActionStatusResp,
  PresenterFullOneFixedAssetResponse,
  PresenterGetPreviousRecordsRequest,
  PresenterIDResponse,
  PresenterImpairFixedAssetRequest,
  PresenterJob,
  PresenterMemorandumRequest,
  PresenterMemorandumResponse,
  PresenterMoveFixedAssetRequest,
  PresenterOneFixedAssetHistoryResponse,
  PresenterOneFixedAssetResponse,
  PresenterOnePreviousFixedAssetEventResponse,
  PresenterResponse,
  PresenterRetireFixedAssetRequest,
  PresenterRevisedAcquisitionCostRequest,
  PresenterRevisedAcquisitionCostResponse,
  PresenterSellFixedAssetRequest,
  PresenterStartUsageFixedAssetRequest,
  PresenterSwitchAssetCategoryRequest,
  PresenterUpdateFixedAssetTypeRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FixedAssets<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description BulkCreate fixed asset
   *
   * @tags fixed_assets
   * @name PostFixedAssetImport
   * @summary BulkCreate the fixed asset
   * @request POST:/fixed_asset_import
   */
  postFixedAssetImport = (
    body: PresenterCreateFixedAssetRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse[];
      },
      PresenterError
    >({
      path: `/fixed_asset_import`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description ValidateCSV from csv file
   *
   * @tags fixed_assets
   * @name PostFixedAssetImportValidateCsv
   * @summary ValidateCSV for importing fixed assets
   * @request POST:/fixed_asset_import/validate_csv
   */
  postFixedAssetImportValidateCsv = (
    data: {
      /** fixed assets csv file to import */
      file: File;
      /** fixed assets csv file to import */
      charset?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse[];
      },
      any
    >({
      path: `/fixed_asset_import/validate_csv`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Get the fixed asset ranges
   *
   * @tags fixed_assets
   * @name GetFixedAssetRanges
   * @summary Get the fixed asset ranges
   * @request GET:/fixed_asset_ranges
   */
  getFixedAssetRanges = (
    query?: {
      "filter[valid_at]"?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetRanges;
      },
      any
    >({
      path: `/fixed_asset_ranges`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the fixed assets list
   *
   * @tags fixed_assets
   * @name GetFixedAssets
   * @summary Get the fixed assets list
   * @request GET:/fixed_assets
   */
  getFixedAssets = (
    query?: {
      "filter[acquire_category]"?: number[];
      "filter[acquire_destination_name]"?: string;
      /** Contains from_date and to_date. If params is omitted, set it to null. If both are omitted, discard this filter. Format: YYYY-MM-DD */
      "filter[acquired_at]"?: string[];
      "filter[acquisition_cost]"?: number[];
      "filter[area_biid]"?: string[];
      "filter[area_codes]"?: string[];
      "filter[asset_category_id]"?: number[];
      "filter[asset_detail_for_corporate_tax]"?: string;
      "filter[asset_status]"?: (1 | 10 | 20 | 29 | 30 | 40)[];
      "filter[asset_structure_for_corporate_tax]"?: string;
      "filter[asset_type_for_corporate_tax]"?: number[];
      "filter[asset_type_for_depreciable_property_tax]"?: number[];
      "filter[biid]"?: string[];
      "filter[branch_code]"?: string;
      "filter[calculate_cost]"?: boolean;
      "filter[category_codes]"?: string[];
      "filter[change_situation]"?: number;
      "filter[code]"?: string;
      "filter[created_at]"?: string[];
      "filter[department_biid]"?: string[];
      "filter[department_codes]"?: string[];
      "filter[depreciation_method_code]"?: number[];
      "filter[event_type_code]"?: 10 | 20 | 30 | 40 | 50 | 60 | 70;
      "filter[exemption_denominator]"?: number;
      "filter[exemption_numerator]"?: number;
      "filter[include_history]"?: boolean;
      "filter[is_get_detail_one_fixed_asset]"?: boolean;
      "filter[is_retroactive]"?: boolean;
      "filter[journal_id]"?: number;
      "filter[keyword]"?: string;
      "filter[memo]"?: string;
      "filter[name]"?: string;
      "filter[name_kana]"?: string;
      "filter[pre_submit_number]"?: string;
      "filter[quantity]"?: number[];
      "filter[service_life]"?: number[];
      "filter[tag]"?: string[];
      "filter[unit_id]"?: number[];
      "filter[usage_started_at]"?: string[];
      "filter[valid_at]"?: string;
      "page[number]"?: number;
      "page[size]"?: number;
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse[];
      },
      any
    >({
      path: `/fixed_assets`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create fixed asset with name
   *
   * @tags fixed_assets
   * @name PostFixedAssets
   * @summary Create the fixed asset
   * @request POST:/fixed_assets
   */
  postFixedAssets = (
    body: PresenterCreateFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete fixed asset with OfficeID
   *
   * @tags fixed_assets
   * @name DeleteFixedAssets
   * @summary Delete the fixed asset
   * @request DELETE:/fixed_assets
   */
  deleteFixedAssets = (params: RequestParams = {}) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/fixed_assets`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description GetActionStatus calculate the action status of fixed assets
   *
   * @tags fixed_assets
   * @name PostFixedAssetsActionsStatus
   * @summary GetActionStatus calculate the action status of fixed assets
   * @request POST:/fixed_assets/actions_status
   */
  postFixedAssetsActionsStatus = (
    body: PresenterFixedAssetsActionStatusReq,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetsActionStatusResp;
      },
      PresenterError
    >({
      path: `/fixed_assets/actions_status`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Bulk update the fixed asset type
   *
   * @tags fixed_assets
   * @name PutFixedAssetsBulkChangeAssetType
   * @summary Bulk update the fixed asset type
   * @request PUT:/fixed_assets/bulk_change/asset_type
   */
  putFixedAssetsBulkChangeAssetType = (
    body: PresenterBulkUpdateAssetTypeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterJob;
      },
      PresenterError
    >({
      path: `/fixed_assets/bulk_change/asset_type`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description BulkDeleteByID deletes a list of asset events
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsBulkChangeDelete
   * @summary BulkDeleteByID deletes a list of asset events
   * @request DELETE:/fixed_assets/bulk_change/delete
   */
  deleteFixedAssetsBulkChangeDelete = (
    body: PresenterBulkDeleteFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterJob;
      },
      PresenterError
    >({
      path: `/fixed_assets/bulk_change/delete`,
      method: "DELETE",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description BulkChangeMove a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsBulkChangeMove
   * @summary BulkChangeMove a fixed asset
   * @request PUT:/fixed_assets/bulk_change/move
   */
  putFixedAssetsBulkChangeMove = (
    body: PresenterBulkChangeMovementReq,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterJob;
      },
      PresenterError
    >({
      path: `/fixed_assets/bulk_change/move`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description BulkChangeRetire a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsBulkChangeRetire
   * @summary BulkChangeRetire a fixed asset
   * @request PUT:/fixed_assets/bulk_change/retire
   */
  putFixedAssetsBulkChangeRetire = (
    body: PresenterBulkRetireFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterJob;
      },
      PresenterError
    >({
      path: `/fixed_assets/bulk_change/retire`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description BulkChangeStartUsage a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsBulkChangeStartUsage
   * @summary BulkChangeStartUsage a fixed asset
   * @request PUT:/fixed_assets/bulk_change/start_usage
   */
  putFixedAssetsBulkChangeStartUsage = (
    body: PresenterBulkUsageFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterJob;
      },
      PresenterError
    >({
      path: `/fixed_assets/bulk_change/start_usage`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Runs non-blocking warning checks for the selected fixed assets using the proposed start-usage date
   *
   * @tags fixed_assets
   * @name PostFixedAssetsBulkChangeStartUsageCheckWarnings
   * @summary Preview warnings for bulk start-usage
   * @request POST:/fixed_assets/bulk_change/start_usage/check_warnings
   */
  postFixedAssetsBulkChangeStartUsageCheckWarnings = (
    body: PresenterCheckBulkStartUsageWarningsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterCheckFixedAssetWarningsResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/bulk_change/start_usage/check_warnings`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Memorandum values from quantity, asset type, unit, and per-ledger depreciation methods. Gin registers this path with Any (all HTTP verbs); the handler uses ShouldBindJSON, so only requests with a JSON body (typically POST) succeed.
   *
   * @tags fixed_assets
   * @name PostFixedAssetsCalculateMemorandum
   * @summary CalculateMemorandumValue calculate the value memorandum value base on the context
   * @request POST:/fixed_assets/calculate_memorandum
   */
  postFixedAssetsCalculateMemorandum = (
    body: PresenterMemorandumRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterMemorandumResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/calculate_memorandum`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Calculates per-ledger revised acquisition cost from usage start date, transition date, acquisition cost, and depreciation method.
   *
   * @tags fixed_assets
   * @name PostFixedAssetsCalculateRevisedAcquisitionCost
   * @summary Calculate revised acquisition cost for migrated assets
   * @request POST:/fixed_assets/calculate_revised_acquisition_cost
   */
  postFixedAssetsCalculateRevisedAcquisitionCost = (
    body: PresenterRevisedAcquisitionCostRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterRevisedAcquisitionCostResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/calculate_revised_acquisition_cost`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Runs the same non-blocking warning checks that would apply during create/start-usage, without persisting anything
   *
   * @tags fixed_assets
   * @name PostFixedAssetsCheckWarnings
   * @summary Preview non-blocking warnings for a fixed-asset draft
   * @request POST:/fixed_assets/check_warnings
   */
  postFixedAssetsCheckWarnings = (
    body: PresenterCreateFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterCheckFixedAssetWarningsResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/check_warnings`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get book informations of the fixed asset by BIID (the latest record). Route is POST-only. Unknown BIID returns not found; invalid JSON, validation failure, or invalid BIID format returns bad request.
   *
   * @tags fixed_assets
   * @name PostFixedAssetsDivideBookValue
   * @summary Get book informations of the fixed asset by BIID at dividing
   * @request POST:/fixed_assets/divide/book_value
   */
  postFixedAssetsDivideBookValue = (
    body: PresenterFixedAssetBookValueDividingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetBookValueDividingResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/divide/book_value`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Computes per-ledger standard dates for dividing book values from the fixed asset identified by `biid` at `divided_at`. Route is POST-only (see tenant fixed_assets group). Returns 400 when JSON is invalid or no fixed asset exists for the BIID.
   *
   * @tags fixed_assets
   * @name PostFixedAssetsDivideStandardDate
   * @summary CalculateStandardDateForDividingEvent calculate the standard date for dividing event
   * @request POST:/fixed_assets/divide/standard_date
   */
  postFixedAssetsDivideStandardDate = (
    body: PresenterDivideStandardDateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDivideStandardDateResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/divide/standard_date`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description GetRecalculateHistory depreciation recalculate history
   *
   * @tags fixed_assets
   * @name GetFixedAssetsRecalculateDeprsHistory
   * @summary GetRecalculateHistory the depreciation recalculate history
   * @request GET:/fixed_assets/recalculate_deprs/history
   */
  getFixedAssetsRecalculateDeprsHistory = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDepreciationRecalculateHistoryResponse[];
      },
      PresenterError
    >({
      path: `/fixed_assets/recalculate_deprs/history`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the fixed asset by BIID (the latest record)
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiid
   * @summary Get the fixed asset by BIID (the latest record)
   * @request GET:/fixed_assets/{biid}
   */
  getFixedAssetsByBiid = (
    biid: string,
    query?: {
      /** Valid at date */
      valid_at?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the fixed asset data
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiid
   * @summary Edit the fixed asset data
   * @request PUT:/fixed_assets/{biid}
   */
  putFixedAssetsByBiid = (
    biid: string,
    body: PresenterEditFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete fixed asset with BIID
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiid
   * @summary Delete the fixed asset
   * @request DELETE:/fixed_assets/{biid}
   */
  deleteFixedAssetsByBiid = (biid: string, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterBIIDResponse;
      },
      any
    >({
      path: `/fixed_assets/${biid}`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description comparison between 2 ledgers in terms of depreciation year close with a specific asset
   *
   * @tags fixed_assets, ledger
   * @name GetFixedAssetsByBiidAnnualDepreciation
   * @summary comparison between 2 ledgers in terms of depreciation year close with a specific asset
   * @request GET:/fixed_assets/{biid}/annual_depreciation
   */
  getFixedAssetsByBiidAnnualDepreciation = (
    biid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetAnnualDepreciationResponse[];
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/annual_depreciation`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the fixed asset type
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidAssetType
   * @summary Update the fixed asset type
   * @request PUT:/fixed_assets/{biid}/asset_type
   */
  putFixedAssetsByBiidAssetType = (
    biid: string,
    body: PresenterUpdateFixedAssetTypeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAssetType;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/asset_type`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get book informations of the fixed asset by BIID (the latest record)
   *
   * @tags fixed_assets
   * @name PostFixedAssetsByBiidBookInformations
   * @summary Get book informations of the fixed asset by BIID (the latest record)
   * @request POST:/fixed_assets/{biid}/book_informations
   */
  postFixedAssetsByBiidBookInformations = (
    biid: string,
    body: PresenterFixedAssetBookInformationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetBookInformationResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/book_informations`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Runs the same non-blocking warning checks that would apply during correct, without persisting anything
   *
   * @tags fixed_assets
   * @name PostFixedAssetsByBiidCheckWarnings
   * @summary Preview non-blocking warnings for a fixed-asset correction draft
   * @request POST:/fixed_assets/{biid}/check_warnings
   */
  postFixedAssetsByBiidCheckWarnings = (
    biid: string,
    body: PresenterCorrectFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterCheckFixedAssetWarningsResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/check_warnings`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This function is responsible for modifying event histories after acquisition, start usage or transition Currently, we still don't support yet fixed asset that impaired, sale, retirement, dividing
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidCorrect
   * @summary Correct a fixed asset
   * @request PUT:/fixed_assets/{biid}/correct
   */
  putFixedAssetsByBiidCorrect = (
    biid: string,
    body: PresenterCorrectFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/correct`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Detail depreciationresult for specific fixed_asset with given ledger_setting_id
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiidDepreciationResults
   * @summary Detail the depreciationresult
   * @request GET:/fixed_assets/{biid}/depreciation_results
   */
  getFixedAssetsByBiidDepreciationResults = (
    biid: string,
    query?: {
      ledger_setting_id?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetDepreciationResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/depreciation_results`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Register accelerated depreciation for specific fixed_asset with given ledger_setting_id
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidDepreciationResultsAdjust
   * @summary Register accelerated depreciation
   * @request PUT:/fixed_assets/{biid}/depreciation_results/adjust
   */
  putFixedAssetsByBiidDepreciationResultsAdjust = (
    biid: string,
    body: PresenterAcceleratedDepreciationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetDepreciationResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/depreciation_results/adjust`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel accelerated depreciation for specific fixed_asset with given ledger_setting_id
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidDepreciationResultsCancelAdjust
   * @summary Cancel accelerated depreciation
   * @request PUT:/fixed_assets/{biid}/depreciation_results/cancel_adjust
   */
  putFixedAssetsByBiidDepreciationResultsCancelAdjust = (
    biid: string,
    body: PresenterCancelAcceleratedDepreciationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/fixed_assets/${biid}/depreciation_results/cancel_adjust`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns monthly original depreciation for the fixed asset and ledger setting
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiidDepreciationResultsOriginalByLedgerSettingId
   * @summary List original depreciation amounts for a ledger
   * @request GET:/fixed_assets/{biid}/depreciation_results/original/{ledger_setting_id}
   */
  getFixedAssetsByBiidDepreciationResultsOriginalByLedgerSettingId = (
    biid: string,
    ledgerSettingId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDepreciationMonthlyResponse[];
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/depreciation_results/original/${ledgerSettingId}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate cancel accelerated depreciation for specific fixed_asset with given ledger_setting_id
   *
   * @tags fixed_assets
   * @name PostFixedAssetsByBiidDepreciationResultsValidateCancelAdjust
   * @summary Validate cancel accelerated depreciation
   * @request POST:/fixed_assets/{biid}/depreciation_results/validate_cancel_adjust
   */
  postFixedAssetsByBiidDepreciationResultsValidateCancelAdjust = (
    biid: string,
    body: PresenterCancelAcceleratedDepreciationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterResponse, PresenterError>({
      path: `/fixed_assets/${biid}/depreciation_results/validate_cancel_adjust`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Divide to preview before dividing
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidDivide
   * @summary Divide to preview before dividing
   * @request PUT:/fixed_assets/{biid}/divide
   */
  putFixedAssetsByBiidDivide = (
    biid: string,
    body: PresenterDivideAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse[];
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/divide`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description DividingCalculate to preview before dividing
   *
   * @tags fixed_assets
   * @name PostFixedAssetsByBiidDividingCalculate
   * @summary DividingCalculate to preview before dividing
   * @request POST:/fixed_assets/{biid}/dividing_calculate
   */
  postFixedAssetsByBiidDividingCalculate = (
    biid: string,
    body: PresenterDivideAssetPreviewRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterDivideAssetPreviewResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/dividing_calculate`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Impair a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidImpair
   * @summary Impair a fixed asset
   * @request PUT:/fixed_assets/{biid}/impair
   */
  putFixedAssetsByBiidImpair = (
    biid: string,
    body: PresenterImpairFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/impair`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description This function is responsible for checking a fixed asset to be corrected or not
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiidIsCorrectable
   * @summary IsCorrectable a fixed asset
   * @request GET:/fixed_assets/{biid}/is_correctable
   */
  getFixedAssetsByBiidIsCorrectable = (
    biid: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: boolean;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/is_correctable`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Move a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidMove
   * @summary Move a fixed asset
   * @request PUT:/fixed_assets/{biid}/move
   */
  putFixedAssetsByBiidMove = (
    biid: string,
    body: PresenterMoveFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/move`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get book information preview for planned events (retirement, sale, partial impairment, etc.) with depreciation rate information
   *
   * @tags fixed_assets
   * @name PostFixedAssetsByBiidPlanEvent
   * @summary Preview book information for event planning
   * @request POST:/fixed_assets/{biid}/plan_event
   */
  postFixedAssetsByBiidPlanEvent = (
    biid: string,
    body: PresenterFixedAssetBookInformationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFixedAssetBookInformationResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/plan_event`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the fixed asset by BIID (the all records)
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiidRecords
   * @summary Get the fixed asset by BIID (the all records)
   * @request GET:/fixed_assets/{biid}/records
   */
  getFixedAssetsByBiidRecords = (biid: string, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetHistoryResponse[];
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the fixed asset record by ID
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiidRecordsById
   * @summary Get the fixed asset record by ID
   * @request GET:/fixed_assets/{biid}/records/{id}
   */
  getFixedAssetsByBiidRecordsById = (
    biid: string,
    id: number,
    query?: {
      /** Set true if want to get deleted record */
      includes_deleted?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete fixed asset with id
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsById
   * @summary Delete the fixed asset
   * @request DELETE:/fixed_assets/{biid}/records/{id}
   */
  deleteFixedAssetsByBiidRecordsById = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the divide fixed asset event
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsByIdDivide
   * @summary Delete the dividing fixed asset event
   * @request DELETE:/fixed_assets/{biid}/records/{id}/divide
   */
  deleteFixedAssetsByBiidRecordsByIdDivide = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/divide`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the movement event a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidRecordsByIdMove
   * @summary Update the movement event a fixed asset
   * @request PUT:/fixed_assets/{biid}/records/{id}/move
   */
  putFixedAssetsByBiidRecordsByIdMove = (
    biid: string,
    id: number,
    body: PresenterMoveFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/move`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the move fixed asset event
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsByIdMove
   * @summary Delete the move fixed asset event
   * @request DELETE:/fixed_assets/{biid}/records/{id}/move
   */
  deleteFixedAssetsByBiidRecordsByIdMove = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/move`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the previous record of the fixed asset record by ID
   *
   * @tags fixed_assets
   * @name GetFixedAssetsByBiidRecordsByIdPrevious
   * @summary Get the previous record of the fixed asset record by ID
   * @request GET:/fixed_assets/{biid}/records/{id}/previous
   */
  getFixedAssetsByBiidRecordsByIdPrevious = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterFullOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/previous`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the retirement event a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidRecordsByIdRetire
   * @summary Update the retirement event a fixed asset
   * @request PUT:/fixed_assets/{biid}/records/{id}/retire
   */
  putFixedAssetsByBiidRecordsByIdRetire = (
    biid: string,
    id: number,
    body: PresenterRetireFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/retire`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the retire fixed asset event
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsByIdRetire
   * @summary Delete the retire fixed asset event
   * @request DELETE:/fixed_assets/{biid}/records/{id}/retire
   */
  deleteFixedAssetsByBiidRecordsByIdRetire = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/retire`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the sell event a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidRecordsByIdSell
   * @summary Update the sell event a fixed asset
   * @request PUT:/fixed_assets/{biid}/records/{id}/sell
   */
  putFixedAssetsByBiidRecordsByIdSell = (
    biid: string,
    id: number,
    body: PresenterSellFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/sell`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the sell fixed asset event
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsByIdSell
   * @summary Delete the sell fixed asset event
   * @request DELETE:/fixed_assets/{biid}/records/{id}/sell
   */
  deleteFixedAssetsByBiidRecordsByIdSell = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/sell`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the StartUsage event a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidRecordsByIdStartUsage
   * @summary Update the StartUsage event a fixed asset
   * @request PUT:/fixed_assets/{biid}/records/{id}/start_usage
   */
  putFixedAssetsByBiidRecordsByIdStartUsage = (
    biid: string,
    id: number,
    body: PresenterStartUsageFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/start_usage`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the start_usage fixed asset event
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsByIdStartUsage
   * @summary Delete the start_usage fixed asset event
   * @request DELETE:/fixed_assets/{biid}/records/{id}/start_usage
   */
  deleteFixedAssetsByBiidRecordsByIdStartUsage = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/start_usage`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update the switch_category event a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidRecordsByIdSwitchCategory
   * @summary Update the switch_category event a fixed asset
   * @request PUT:/fixed_assets/{biid}/records/{id}/switch_category
   */
  putFixedAssetsByBiidRecordsByIdSwitchCategory = (
    biid: string,
    id: number,
    body: PresenterSwitchAssetCategoryRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/switch_category`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete the switch_category fixed asset event
   *
   * @tags fixed_assets
   * @name DeleteFixedAssetsByBiidRecordsByIdSwitchCategory
   * @summary Delete the switch_category fixed asset event
   * @request DELETE:/fixed_assets/{biid}/records/{id}/switch_category
   */
  deleteFixedAssetsByBiidRecordsByIdSwitchCategory = (
    biid: string,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/records/${id}/switch_category`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retire a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidRetire
   * @summary Retire a fixed asset
   * @request PUT:/fixed_assets/{biid}/retire
   */
  putFixedAssetsByBiidRetire = (
    biid: string,
    body: PresenterRetireFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/retire`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Sell a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidSell
   * @summary Sell a fixed asset
   * @request PUT:/fixed_assets/{biid}/sell
   */
  putFixedAssetsByBiidSell = (
    biid: string,
    body: PresenterSellFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/sell`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description StartUsage a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidStartUsage
   * @summary StartUsage a fixed asset
   * @request PUT:/fixed_assets/{biid}/start_usage
   */
  putFixedAssetsByBiidStartUsage = (
    biid: string,
    body: PresenterStartUsageFixedAssetRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/start_usage`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description SwitchCategory a fixed asset
   *
   * @tags fixed_assets
   * @name PutFixedAssetsByBiidSwitchCategory
   * @summary SwitchCategory a fixed asset
   * @request PUT:/fixed_assets/{biid}/switch_category
   */
  putFixedAssetsByBiidSwitchCategory = (
    biid: string,
    body: PresenterSwitchAssetCategoryRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneFixedAssetResponse;
      },
      PresenterError
    >({
      path: `/fixed_assets/${biid}/switch_category`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the previous record of the fixed asset record by ID
   *
   * @tags fixed_assets
   * @name PostSearchPreviousFixedAssets
   * @summary Get the previous record of the fixed asset record by ID
   * @request POST:/search/previous_fixed_assets
   */
  postSearchPreviousFixedAssets = (
    body: PresenterGetPreviousRecordsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOnePreviousFixedAssetEventResponse[];
      },
      PresenterError
    >({
      path: `/search/previous_fixed_assets`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
